var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3391 8.94737C16.3391 12.7843 13.2286 15.8947 9.3917 15.8947C5.55478 15.8947 2.44434 12.7843 2.44434 8.94737C2.44434 5.11044 5.55478 2 9.3917 2C13.2286 2 16.3391 5.11044 16.3391 8.94737ZM15.1704 15.7786C13.6114 17.0987 11.5945 17.8947 9.3917 17.8947C4.45021 17.8947 0.444336 13.8889 0.444336 8.94737C0.444336 4.00587 4.45021 0 9.3917 0C14.3332 0 18.3391 4.00587 18.3391 8.94737C18.3391 10.9653 17.6711 12.8272 16.5441 14.324L20.0988 17.8787C20.4894 18.2692 20.4894 18.9024 20.0988 19.2929C19.7083 19.6834 19.0751 19.6834 18.6846 19.2929L15.1704 15.7786Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e80a6c0686a18dcc25bcd5d3bc2e8933.svg";
export { ForwardRef as ReactComponent };